import React, { useRef, useState } from "react";
import {
  AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader,
  AlertDialogBody, AlertDialogFooter, Button, Text,
} from "@chakra-ui/react";
import { PALETTES } from "../classroomColors";

/**
 * Deleting a module takes its lessons with it, so the count is spelled out
 * rather than left for the teacher to remember.
 */
const ConfirmDelete = ({ target, isDark = true, onClose, onConfirm }) => {
  const p = isDark ? PALETTES.dark : PALETTES.light;
  const cancelRef = useRef(null);
  const [working, setWorking] = useState(false);

  const node = target?.node;
  const kind = target?.kind || "item";
  const lessons = node?.child_segments?.length || 0;

  const go = async () => {
    setWorking(true);
    try {
      await onConfirm();
    } finally {
      setWorking(false);
    }
  };

  return (
    <AlertDialog isOpen={Boolean(target)} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
      <AlertDialogOverlay bg={p.overlay}>
        <AlertDialogContent bg={p.surface} color={p.text} borderRadius="14px" border="1px solid"
          borderColor={p.border} maxW="420px" mx="16px">
          <AlertDialogHeader fontSize="17px" fontWeight="500" pb="6px">
            Delete {node?.name}?
          </AlertDialogHeader>
          <AlertDialogBody pt="0">
            <Text fontSize="13.5px" color={p.textSub} fontWeight="300" lineHeight="1.55">
              {kind === "module" && lessons > 0
                ? `This module and its ${lessons} lesson${lessons === 1 ? "" : "s"} will be removed, along with anything attached to them.`
                : "This lesson and anything attached to it will be removed."}
            </Text>
          </AlertDialogBody>
          <AlertDialogFooter gap="8px" pt="16px">
            <Button ref={cancelRef} onClick={onClose} variant="ghost" size="sm" borderRadius="8px"
              color={p.text} _hover={{ bg: p.hover }}>
              Keep it
            </Button>
            <Button onClick={go} isLoading={working} loadingText="Deleting" size="sm" borderRadius="8px"
              bg={isDark ? "#ff8a7a" : "#b3261e"} color={isDark ? "#222222" : "#ffffff"}
              _hover={{ opacity: 0.9 }}>
              Delete
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default ConfirmDelete;
